// import {storage} from '../firebase';

import { storage } from "../firebase";
import shortid from 'short-id';

export async function uploadTaskPromise(file) {
    return new Promise(function(resolve, reject) {
      const storageRef = storage
        .ref("measurements/" + shortid.generate() +file.name);
      const uploadTask = storageRef.put(file);
      uploadTask.on(
        "state_changed",
        function(snapshot) {
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
        },
        function error(err) {
          console.log("error", err);
          reject(err);
        },
        function complete() {
          uploadTask.snapshot.ref
            .getDownloadURL()
            .then(function(downloadURL) {
              resolve(downloadURL);
            });
        }
      );
    });
  }